import React from "react"
import ImageDescriptionNumberItem from "./imageDescriptionNumberItem"

const ImageDescriptionNumber = ({ row }) => {
  return (
    <section className="caseStudyList">
      {row.map((item, index) => {
        const {
          heading,
          description,
          promotetText,
          linkText,
          link,
        } = item.value
        const backroundPaht = item.value.backround.path

        return (
          <ImageDescriptionNumberItem
            key={index}
            index={index}
            heading={heading}
            description={description}
            promotetText={promotetText}
            link={link}
            linkText={linkText}
            backroundPaht={backroundPaht}
          ></ImageDescriptionNumberItem>
        )
      })}
    </section>
  )
}

export default ImageDescriptionNumber
